module.exports = __webpack_public_path__ + "static/media/checkedEmptyImage.ec59a485.svg";